import { useEffect, useRef } from 'react';

type Props = {
    html: string;
}

const HtmlParser: React.FC<Props> = ({ html }) => {
    const container = useRef<HTMLDivElement>(null)
    useEffect(() => {
        if (container.current) {
            let processedHtml = html.replace(/\\"/g, '"')
            // Add referrerPolicy="no-referrer" to all img tags
            processedHtml = processedHtml.replace(/<img\s+([^>]*?)>/gi, (match) => {
                if (match.includes('referrerPolicy')) {
                    return match;
                }
                return match.replace(/\s*>/, ' referrerPolicy="no-referrer">');
            })
            container.current.innerHTML = processedHtml
        }
    }, [html])
    return (
        <div ref={container} style={{ overflow: "auto" }}>
        </div>
    );
};

export default HtmlParser;
